import axios from 'axios'

const baseUrl = 'https://www.potterapi.com/v1'
const apiKey = `?key=$2a$10$iws3us.${process.env.REACT_APP_HARRY_POTTER_KEY1}`

export const getAllCharacters = () => {
  return axios.get(`${baseUrl}/characters${apiKey}`)
}

export const getAllSpells = () => {
  return axios.get(`${baseUrl}/spells${apiKey}`)
}